{
  "ui": {
    "feedback": "Обратна връзка",
    "credits": "Екип",
    "currentMaintainer": "Текуща поддръжка",
    "maintainerPeriod": "От 2026 г. нататък",
    "originalTeam": "Оригинален екип",
    "creditsCampaigns": "Джунгла и Коледа",
    "moreSettings": "Още настройки",
    "chooseLanguage": "Избери език",
    "notebookTools": "Инструменти на тетрадката",
    "visualGuide": "Ръководство с картинки",
    "templeSoon": "Очаквайте скоро",
    "playAdventure": "Играй",
    "story": "Историята",
    "loadingAdventure": "Подготвяме се за приключението…",
    "storyOpening": "Училищна екскурзия в джунглата. Марко и София изследват с приятелите си. Цветна птица привлича вниманието на Марко и той я следва между дърветата. Изведнъж остава сам. Помогни на изследователите да намерят пътя!",
    "storyEnding": "Марко и София стигат заедно до изгубения храм. Загадъчно лице пази входа. Очаква ги ново приключение!",
    "blockCategories": "Раздели на тетрадката",
    "actions": "Действия",
    "loops": "Цикли",
    "conditions": "Условия",
    "title": "Run Marco! — Приключение в твоята тетрадка",
    "home": "Начална страница на Run Marco",
    "map": "Карта на приключението",
    "worlds": "Избери приключение",
    "notebook": "Моята тетрадка",
    "notebookToggle": "Отвори или затвори тетрадката",
    "notebookOpen": "Отвори тетрадката",
    "notebookClose": "Наблюдавай пътеката",
    "page": "Страница {number}",
    "level": "Пътека {number}",
    "run": "Да тръгваме!",
    "stop": "Спри",
    "step": "Една стъпка",
    "stepTitle": "Изпълни една команда",
    "reset": "Обратно в началото",
    "add": "Добави",
    "addLabel": "Избери блок за добавяне",
    "addHint": "Свържи блоковете и натисни Играй.",
    "undo": "Отмени",
    "clear": "Нова страница",
    "hint": "Малък съвет",
    "help": "Как се играе",
    "settings": "Настройки",
    "language": "Език на играта",
    "blockLanguage": "Език на блоковете",
    "blockLanguageNote": "Можеш да избереш друг език за блоковете.",
    "musicOn": "Включи звука",
    "musicOff": "Изключи звука",
    "sound": "Музика и звукови ефекти",
    "speed": "Скорост на приключението",
    "chooseExplorer": "Избери изследовател",
    "explorer": "Изследовател",
    "marco": "Марко",
    "sophia": "София",
    "close": "Затвори",
    "done": "Да изследваме!",
    "loading": "Търсим пътеката…",
    "loadError": "Приключението не можа да се зареди. Презареди страницата и опитай отново.",
    "imageError": "Някои картинки не можаха да се заредят. Презареди страницата.",
    "gemGoal": "Намери скъпоценния камък",
    "goal": "Намери златната звезда",
    "cover": "Освети всяко поле само веднъж",
    "lit": "Осветени полета: {count} / {total}",
    "explored": "Изследвани пътеки: {count} / {total}",
    "facing": "Гледа {direction} {arrow}",
    "boardLabel": "{name} на {level}, гледа {direction}. {steps}. {objective}.",
    "up": "нагоре",
    "down": "надолу",
    "left": "наляво",
    "right": "надясно",
    "steps_one": "{count} стъпка",
    "steps_other": "{count} стъпки",
    "blocks_one": "{count} блок",
    "blocks_other": "{count} блока",
    "stars_one": "{count} звезда",
    "stars_other": "{count} звезди",
    "place": "Добави блокове",
    "atEnd": "Накрая",
    "insideRepeat": "В повторение {number}",
    "insideIf": "В ако {number}",
    "insideElse": "В иначе {number}",
    "readyFirst": "Една малка стъпка. Добави блок напред и да тръгваме!",
    "ready": "Накъде ще вървим? Направи план в тетрадката.",
    "back": "Отново в началото. Блоковете са готови за нов опит.",
    "empty": "Първо добави блок в тетрадката.",
    "win": "Намери пътя!",
    "winCover": "Освети пътеката!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Какво приключение!",
    "simpler": "Можеш ли с по-малко блокове?",
    "complete": "Пътеката е завършена! Най-добрите ти звезди са запазени.",
    "next": "Следваща пътека",
    "allWorlds": "Още приключения",
    "replay": "Играй отново",
    "shortGoal": "Почти! Добави още блокове, за да стигнеш до звездата.",
    "shortGem": "Почти! Добави още блокове, за да стигнеш до скъпоценния камък.",
    "shortCover": "Някои полета са още тъмни. Как да стигнем до тях?",
    "checking": "Наблюдаваме пътеката…",
    "paused": "Спряно. Играй започва отново от началото.",
    "going": "На път!",
    "stepped": "Една стъпка по-близо. Натисни Една стъпка или Играй, за да продължиш.",
    "clueCover": "Започни от края и обходи цялата фигура. Скокът прескача поле, без да го осветява.",
    "clueCondition": "Погледни пътеката пред теб. Условието помага на изследователя да избере действие.",
    "clueRepeat": "Кои стъпки се повтарят? Постави този модел в блок за повторение.",
    "clueForward": "Напред следва посоката на погледа на изследователя. Преброй полетата до звездата.",
    "clueGem": "Напред следва посоката на погледа на изследователя. Преброй полетата до скъпоценния камък.",
    "clueTurn": "Завъртането сменя посоката без придвижване. Проследи пътеката с пръст.",
    "mapNote": "Избери пътека. Най-добрите ти звезди се запазват.",
    "mapLevel": "Пътека {number}: {name}. {stars}.",
    "locked": "Завърши предишната пътека, за да отключиш тази.",
    "soundBlocked": "Докосни бутона за звук, за да чуеш приключението.",
    "clearTitle": "Да започнем нова страница?",
    "clearNote": "Блоковете за тази пътека ще бъдат изтрити. Отмени може да ги върне.",
    "keep": "Запази моите блокове",
    "clearConfirm": "Изтрий блоковете",
    "fresh": "Нова страница. Накъде ще ни отведе следващият ти план?",
    "localProgress": "Напредъкът ти се запазва на това устройство.",
    "helpBuild": "Направи план",
    "helpBuildText": "Плъзни блокове в тетрадката и ги свържи или докосни блок, за да го добавиш. Избери „В повторение“, за да добавиш стъпки в цикъл.",
    "helpTurn": "Следвай изследователя",
    "helpTurnText": "Напред следва погледа. Наляво и надясно завъртат на място. Скокът изминава две полета.",
    "helpTry": "Опитай, наблюдавай и опитай отново",
    "helpTryText": "Натисни Играй за плана или Една стъпка за една команда. Извитата стрелка връща в началото и запазва блоковете.",
    "helpWorlds": "Всяко приключение има цел",
    "helpWorldsText": "В Джунглата намери скъпоценния камък. В коледното приключение освети всяко свободно поле веднъж. В Храма и Егейско море направи поправките, изпълни показаните цели и стигни до изхода.",
    "noTrail": "Там няма пътека! Опитай първо да се завъртиш.",
    "broken": "Този мост е счупен. Можеш ли да го прескочиш?",
    "blocked": "Нещо пречи на пътя. Опитай скок или друг маршрут.",
    "alreadyLit": "Това поле вече свети. Посети всяко поле само веднъж.",
    "loopError": "Този план се повтаря безкрайно. Опитай да промениш цикъла.",
    "repeatError": "Избери брой повторения от 1 до 99.",
    "unsupported": "Премахни неподдържания блок и опитай отново.",
    "connect": "Свържи блоковете в една верига и натисни Играй.",
    "path": "пътека",
    "backpack": "Раница",
    "templeGems": "Скъпоценните камъни на храма",
    "gemsCollected": "Скъпоценни камъни: {count} / {total}",
    "gemsReady": "Всички скъпоценни камъни са събрани!",
    "aegeanTitle": "Тайните на Егейско море",
    "harbour": "Пристанище",
    "aegeanDescription": "Изследвай пристанището: поправяй станции, използвай подпрограми многократно и изпращай число с всяка поръчка.",
    "templeBetaNote": "Бета · Преработваме загадките и уроците",
    "aegeanBetaNote": "Бета · Първите 3 нива в пристанището",
    "seasonal": "Сезонно приключение",
    "choosePreview": "Избери пробно ниво",
    "repairs": "Поправки",
    "reachExit": "Стигни до изхода",
    "taskRequirements": "Цели на задачата",
    "lessonGuided": "Упражнение с помощ · допълни готовата програма",
    "lessonRepair": "Откриване на грешки · поправи готовата програма",
    "lessonChallenge": "Предизвикателство · създай своя програма",
    "acc_define_parameter": "Подпрограма",
    "acc_call_argument": "Извикай подпрограма",
    "acc_repeat_parameter": "Повтаряй с вход",
    "parameter": "параметър",
    "argument": "изпрати",
    "callInput": "Входът на това извикване",
    "inputWaiting": "Стартирай програмата или изпълни една команда, за да видиш следващия вход.",
    "argumentMismatch": "Подпрограма с параметър изисква извикване с число. Без параметър използвай обикновено извикване.",
    "unsetParameter": "Използвай параметъра само в подпрограмата, която го получава. Параметрите са отделни от споделената памет.",
    "memoryObjective": "Провери записа на поправките и изискванията при изхода. Приема се всяка програма, която ги изпълнява.",
    "gate": "Пътят е блокиран. Провери незавършените ремонти.",
    "noPickup": "Стъпи върху инструмента, преди да го вземеш.",
    "creditLead": "Ръководство на екипа и разработка на софтуер",
    "creditArt": "Илюстрации и декори",
    "creditAnimation": "Анимация",
    "creditUX": "Дизайн на интерфейса и потребителското изживяване",
    "creditDesign": "Дизайн на играта",
    "creditStory": "Създаване на историята",
    "creditAudio": "Музика и звукотехника",
    "lightLamp": "Запали лампата",
    "oilLamp": "Маслена лампа",
    "dustyStation": "прашна станция",
    "betaLabel": "Бета",
    "noLamp": "Стъпи върху изгасена лампа, преди да я запалиш.",
    "collected": "Инструментът е взет · готов за употреба",
    "dustyPrompt": "Стъпи върху прашна станция, преди да използваш четката.",
    "lampMissing": "Първо вземи маслената лампа. Погледни в раницата.",
    "recursiveRoutine": "Тази подпрограма извиква сама себе си. Използвай друга подпрограма; рекурсивните извиквания още не са достъпни."
  },
  "content": {
    "jungle.title": "Експедиция в джунглата",
    "jungle.description": "Следвай пътеката до изгубения храм.",
    "jungle-1": "Първи стъпки",
    "jungle-2": "Малко по-далеч",
    "jungle-3": "Зад ъгъла",
    "jungle-4": "Смени посоката",
    "jungle-5": "Следвай пътеката",
    "jungle-6": "Нов маршрут",
    "jungle-7": "Нови пътеки",
    "jungle-8": "Кръстопът в джунглата",
    "jungle-9": "Намери пътя",
    "jungle-10": "Мисли напред",
    "jungle-11": "Дългата пътека",
    "jungle-12": "Криволичещ маршрут",
    "jungle-13": "Смел скок",
    "jungle-14": "Появяват се модели",
    "jungle-15": "Повтори ритъма",
    "jungle-16": "Избери пътека",
    "jungle-17": "Погледни преди скока",
    "jungle-18": "Разчети пътеката",
    "jungle-19": "Умен обход",
    "jungle-20": "Под короните",
    "jungle-21": "Строител на мостове",
    "jungle-22": "Отвъд реката",
    "jungle-23": "Изследвай руините",
    "jungle-24": "Камък и дърво",
    "jungle-25": "По-голям скок",
    "jungle-26": "Следвай следите",
    "jungle-27": "По-нависоко",
    "jungle-28": "Продължи да изследваш",
    "jungle-29": "Криволичещи пътеки",
    "jungle-30": "Тайната градина",
    "jungle-31": "Скрити модели",
    "jungle-32": "Древни пътеки",
    "jungle-33": "Последните завои",
    "jungle-34": "Към храма",
    "jungle-35": "Почти стигнахме",
    "jungle-36": "Изгубеният храм",
    "winter.title": "Зимна пътека",
    "winter.description": "Остави светлина във всяка следа.",
    "winter-1": "Стъпки в снега",
    "winter-2": "Друга посока",
    "winter-3": "Замръзнали ъгли",
    "winter-4": "Дългият обход",
    "winter-5": "Снежинка",
    "winter-6": "Зимни цикли",
    "winter-7": "Изследовател на леда",
    "winter-8": "Завои и обрати",
    "winter-9": "Ледена логика",
    "winter-10": "Търсач на модели",
    "winter-11": "Майстор на пътеката",
    "winter-12": "Зимно чудо",
    "temple.title": "Изгубеният храм",
    "temple.description": "Четиридесет свързани стаи. Възстанови небесния уред с инструменти, памет и собствени подпрограми."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Кошчето е празно",
    "OPEN_TRASH": "Отвори кошчето",
    "BLOCK_LABEL_BEGIN_STACK": "Начало на веригата",
    "WORKSPACE_LABEL_1_STACK": "1 верига от блокове",
    "WORKSPACE_LABEL_MANY_STACKS": "Вериги от блокове: %1",
    "ARIA_TYPE_FIELD_NUMBER": "число",
    "ARIA_TYPE_FIELD_DROPDOWN": "падащ списък",
    "ARIA_TYPE_FIELD_IMAGE": "картинка",
    "WORKSPACE_LABEL_PLAIN": "Моята тетрадка",
    "FIELD_LABEL_EDIT_PREFIX": "Редактирай %1",
    "BLOCK_LABEL_HAS_INPUT": "има вход",
    "BLOCK_LABEL_HAS_INPUTS": "има входове",
    "BLOCK_LABEL_HAS_BRANCHES": "разклонения: %1",
    "FIELD_LABEL_OPTION_INDEX": "Опция %1",
    "INPUT_LABEL_EMPTY": "Празно",
    "BLOCK_LABEL_DISABLED": "изключено",
    "BLOCK_LABEL_COLLAPSED": "свито",
    "BLOCK_LABEL_BEGIN_PREFIX": "Начало: %1",
    "INPUT_LABEL_END_STATEMENT": "Край: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "текст",
    "ARIA_TYPE_FIELD_INPUT": "вход",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "име на входа",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "име на подпрограмата"
  }
}
